import { ProgressCircleComponent } from "@/components/progress/progress-circle";
import { Tooltip } from "@/components/ui/tooltip";
import { ContactRequestStatus } from "@/constants/entity-status";
import { ContactRequest } from "@/services/contact.service";
import { AppColors } from "@/styles/colors";
import {
  Box,
  Checkbox,
  CheckboxCheckedChangeDetails,
  Field,
  Text,
} from "@chakra-ui/react";

// Fuera del componente ContactPage
interface ContactActionProps {
  item: ContactRequest;
  selectedToContact?: ContactRequest;
  loading: boolean;
  hasPermission: boolean;
  onCheck: (
    checked: CheckboxCheckedChangeDetails,
    item: ContactRequest,
  ) => void;
}

export const ContactAction = ({
  item,
  selectedToContact,
  loading,
  hasPermission,
  onCheck,
}: ContactActionProps) => {
  const disabled =
    !hasPermission ||
    (selectedToContact?.id !== item.id && loading) ||
    item?.idEstado === ContactRequestStatus.CONTACTED;

  if (selectedToContact?.id === item.id && loading) {
    return (
      <Box>
        <ProgressCircleComponent size="xs" />
      </Box>
    );
  }

  return (
    <Box>
      <Tooltip
        openDelay={500}
        closeDelay={100}
        positioning={{ placement: "left" }}
        content={
          <Text fontSize="14px">
            {item?.idEstado === ContactRequestStatus.CONTACTED
              ? "Usuario contactado"
              : "Contactar usuario"}
          </Text>
        }
        contentProps={{
          css: {
            paddingX: "10px",
            "--tooltip-bg": AppColors.GREEN_PRIMARY,
          },
        }}
      >
        <Field.Root disabled={disabled}>
          <Checkbox.Root
            data-testid="checkbox-contact"
            cursor={disabled ? "default" : "pointer"}
            checked={item?.idEstado === ContactRequestStatus.CONTACTED}
            onCheckedChange={(checked) => onCheck(checked, item)}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control
              data-testid="checkbox-contact-control"
              borderColor={AppColors.GRAY_BORDER_1}
            />
          </Checkbox.Root>
        </Field.Root>
      </Tooltip>
    </Box>
  );
};
